import { useState } from "react";

export type PayMethod = "azul" | "manual_transfer" | "cod";
export type ShippingId = "standard" | "express" | "national" | "pickup";

export type AzulPending = {
  orderId: string;
  amountDop: number;
  itbisDop: number;
} | null;

/**
 * Owns the wizard-like checkout state. Side effects (DB insert, toasts,
 * cart clearing, reward points) stay in the caller because they cross
 * multiple domains. This hook just tracks the form state cleanly.
 */
export function useCheckout() {
  const [ckStep, setCkStep] = useState(0);
  const [shipId, setShipId] = useState<ShippingId>("standard");
  const [payMethod, setPayMethod] = useState<PayMethod>("manual_transfer");
  const [orderDone, setOrderDone] = useState(false);
  const [promoCode, setPromoCode] = useState("");
  const [appliedPromo, setAppliedPromo] = useState<string | null>(null);
  // When payMethod === "azul" we don't mark the order done immediately;
  // we stash the pending payment payload so the AZUL form can render and
  // capture the card before confirming the order.
  const [azulPending, setAzulPending] = useState<AzulPending>(null);

  const reset = () => {
    setCkStep(0);
    setOrderDone(false);
    setAppliedPromo(null);
    setPromoCode("");
    setAzulPending(null);
  };

  const next = () => setCkStep((s) => Math.min(2, s + 1));
  const back = () => setCkStep((s) => Math.max(0, s - 1));

  return {
    ckStep, setCkStep, next, back,
    shipId, setShipId,
    payMethod, setPayMethod,
    orderDone, setOrderDone,
    promoCode, setPromoCode,
    appliedPromo, setAppliedPromo,
    azulPending, setAzulPending,
    reset,
  };
}